import React from 'react';
import PropTypes from 'prop-types';

import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {OEObjectModelValueTypes, OEObjectModelValueCellStyleOptions, OEObjectModelValueEditDecls} from '../oe-object-model-value-edit-model';
import OEObjectModelGroupCell from './oe-object-model-group-cell.js';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelBitCheckboxListCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    render()    {
        let {type, entries, value, ...rest} = this.props;
        if(typeof(value) !== 'number')  value = 0;

        const styleOptions = OEObjectModelValueCellStyleOptions.inlineBar;

        let subItems = this.props.entries.map((entry, index) => {
            return {
                name:               String(index),
                type:               OEObjectModelValueTypes.bool,
                label:              entry.label,
                showType:           false,
                styleOptions:       styleOptions,
                value:              (entry.value & value) == entry.value
            };
        });

        return (
            <OEObjectModelGroupCell
                {...rest}
                type={OEObjectModelValueTypes.group}
                subItems={subItems}
                onChange={this.onChange}
            />
        );
    }

    onChange(sender, name, checkBoxValue)  {
        let index = Math.floor(name);
        if(index < 0 && index >= this.props.entries.length) return;
        let entry = this.props.entries[index];
        if(typeof(entry.value) !== 'number' || entry.value === 0)   return;

        let value = typeof(this.props.value) === 'number' ? this.props.value : 0;
        let newValue = OEToolbox.binaryAddRemove(value, entry.value, !checkBoxValue);

        if(value === newValue)  return;
        if(this.props.onChange)   this.props.onChange(this, this.props.name, newValue);
    }
};

OEObjectModelBitCheckboxListCell.defaultProps = Object.assign({
    disabled:                   false,
    entries:                    []
}, OEObjectModelValueCell.defaultProps, {
    showType:                   false
});

OEObjectModelBitCheckboxListCell.propTypes = Object.assign({
    cellClassName:              PropTypes.string,
    disabled:                   PropTypes.bool,
    entries:                    OEObjectModelValueEditDecls.bitCheckboxListCellEntries,
    value:                      PropTypes.number
}, OEObjectModelValueCell.propTypes);